
(function($) {
	var ContactView = Backbone.View.extend(_.extend({}, App._base, {
		el: '.contact-section',

		wraps: null,
		fields: null,
		$form: null,
		$reset: null,

		// Put variables here

		activeClass: 'active',
		hasTextClass: 'has-text', 


		// Put functionality here

		// TODO: Inherit all the resize stuff
		OnWindowResize: function(e) {
			clearTimeout(this.resizeDebounce);
			this.resizeDebounce = setTimeout(this.proxy(function() {
				this.SetSectionHeight();
			}), 250);
		},

			SetSectionHeight: function() {
				if (this.isTablet()) {
					this.$el.removeAttr('style');
					return;
				}

				var wh = $(window).height(),
					fh = $('.main-footer').outerHeight(),
					eh = wh - fh;
				this.$el.outerHeight(eh);
			},

		bindEvents: function() {
			// Bind the focus events on the entry boxes
			// Just need to add the correct class to the
			// container.
			this.fields
				.focus(this.proxy(this.OnInputFocus))
				.blur(this.proxy(this.OnInputBlur));

			this.$reset.click(this.proxy(this.OnResetClick));

			$(window).resize(this.proxy(this.OnWindowResize));
		},

			OnInputFocus: function(e) {
				var $$ = $(e.currentTarget),
					$p = $$.parent();

				$p.addClass(this.activeClass);
				$p.removeClass(this.hasTextClass);
			},

			OnInputBlur: function(e) {
				var $$ = $(e.currentTarget),
					$p = $$.parent(),
					val = $$.val();

				$p.removeClass(this.activeClass);
				if (val !== '') {
					$p.addClass(this.hasTextClass);
				}
			},

			OnResetClick: function(e) {
				this.$form.get(0).reset();
				this.wraps
					.removeClass(this.activeClass)
					.removeClass(this.hasTextClass);
				this.fields
					.blur();
			},


		ready: function() {
			if (this.isMobile()) { return; }
			
			this.bindEvents();
			this.SetSectionHeight();
		},

		initialize: function(options) {
			this.wraps = $('.field-wrap', this.$el);
			this.fields = $('.field-wrap .ninja-forms-field', this.$el);
			this.$form = $('form', this.$el);
			this.$reset = $('.reset-button', this.$el);

			App.Events.on('ready', this.proxy(this.ready)); 
		}
	}));

	App.Views.Contact = new ContactView();
})(jQuery);  